module.exports = __webpack_public_path__ + "img/insurita-value-three.d7df8c3b.png";